module.exports = __webpack_public_path__ + "img/parking_entrance_underground.1b538f93.svg";